import { render, staticRenderFns } from "./UserPermissionsCard.vue?vue&type=template&id=3d03ba62&scoped=true&"
import script from "./UserPermissionsCard.vue?vue&type=script&lang=ts&"
export * from "./UserPermissionsCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserPermissionsCard.vue?vue&type=style&index=0&id=3d03ba62&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d03ba62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardActions,VCardSubtitle,VCardText,VCardTitle,VIcon,VSpacer,VTextField,VTooltip})
